// Square categories whose name starts with "[R]" are internal reporting
// categories and must never be shown to customers.
export const isReportingCategory = (name) =>
  typeof name === 'string' && name.trim().startsWith('[R]');

// Returns the category name for display, or null if it is a reporting category.
export const visibleCategory = (name) => (isReportingCategory(name) ? null : name || null);

// Walks an API response and drops reporting-category names from every
// `categories` list of plain category names (as found on catalog items).
export const stripReportingNames = (value) => {
  if (Array.isArray(value)) return value.map(stripReportingNames);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [
        key,
        key === 'categories' && Array.isArray(val) && val.every((v) => typeof v === 'string')
          ? val.filter((v) => !isReportingCategory(v))
          : stripReportingNames(val),
      ])
    );
  }
  return value;
};

// Removes reporting categories (and their descendants) from a category tree.
export const stripReportingCategories = (nodes) =>
  (nodes || [])
    .filter((n) => !isReportingCategory(n.name))
    .map((n) => (n.children ? { ...n, children: stripReportingCategories(n.children) } : n));
